<span class="p-input-icon-left block">
  <i class="pi pi-search z-1"></i>
<p-autoComplete
  [suggestions]="filteredResults"
  (completeMethod)="getResult($event)"
  (onSelect)="handleManualFieldValueAssignment(formGroup,formField.id,$event.value.id)"
  optionLabel="name"
  styleClass="w-full"
  panelStyleClass="w-full"
  inputStyleClass="w-full"
  class="w-full"
  [showClear]="true"
  (onClear)="handleClear()"
  [(ngModel)]="selectedItem"
  [inputStyle]="{'padding-left': '2.5rem', width: '100%'}"
  placeholder="{{formField.uiPlaceholder}}"
></p-autoComplete>
</span>

